import {
    Page,
    Reorder,
    Resize,
    Toolbar,
    PdfExport,
    ExcelExport,
    Search,
    Sort,
    ColumnMenu,
    Group,
    Filter,
    Selection
} from "@syncfusion/ej2-react-grids";

/**
 * @author IKlapouch
 * 11/02/2021
 **/

export class DataGridDefaultProps {

    getToolBarCustom(items) {
        let result = ["Search"];
        if (Array.isArray(items) && items.length) {
            items.forEach((item) => result.push(item));
        }
        return result;
    }

    getToolBarItemsExport(items) {
        let result = ["ExcelExport", "Search"];
        if (Array.isArray(items) && items.length) {
            items.forEach((item) => result.push(item));
        }
        return result;
    }

    getToolBarItems(items) {
        let result = ["Search"];
        if (Array.isArray(items) && items.length) {
            items.forEach((item) => result.push(item));
        }
        return result;
    }

    getGroupOptions(items) {
        let result = { showGroupedColumn: true };
        if (Array.isArray(items) && items.length) {
            items.forEach((item) => result);
        }
        return result;
    }

    getFilterSettings(items) {
        let result = { type: "CheckBox" };
        if (items) {
            result = {
                ...result,
                ...items,
            };
        }
        return result;
    }

    getServices(items) {
        let result = [
            Page,
            Reorder,
            Resize,
            Toolbar,
            PdfExport,
            ExcelExport,
            Search,
            Sort,
            ColumnMenu,
            Group,
            Filter,
            Selection
        ]
        if (items) {
            result = {
                ...result,
                ...items,
            }
        }
        return result
    }

    getSelectionSettings() {
        return { cellSelectionMode: "Box", type: "Single", mode: "Cell" };
    }
}
